import $ from "jquery";
window.jQuery = $;
window.$      = $;

$(function ($) {
    $.fn.countdown = function (options) {
        return $(this).each(function () {
            const countdownEndDate = options && options.endDate ? options.endDate : $(this).data("enddate");

            if (!countdownEndDate) return;

            const formatedEndDate = new Date(countdownEndDate);

            if (!isValidDate(formatedEndDate)) return;

            $(this).trigger("countdown:initialized", this);

            setCountdown(formatedEndDate, $(this));
        });

        function isValidDate(date) {
            return date instanceof Date && !isNaN(date);
        }

        function setCountdown(date, $this) {
            const countdownTimout = setInterval(() => {
                let diffSeconds = getDiffSeconds(date);

                if (Math.floor(diffSeconds) <= 0) {
                    clearInterval(countdownTimout);
                    diffSeconds = 0;
                    $this.trigger("countdown:finished");
                }

                const currentLeftTime = getLeftTime(diffSeconds);

                $this.trigger("countdown:update", currentLeftTime);
            }, 1000);
        }

        function getDiffSeconds(endDate) {
            const diffDates   = endDate - new Date();
            const diffSeconds = diffDates / 1000;

            return diffSeconds;
        }

        function getLeftTime(diffSeconds) {
            const days = Math.floor(diffSeconds / 60 / 60 / 24);
            const hour = Math.floor(diffSeconds / 60 / 60) % 24;
            const min  = Math.floor(diffSeconds / 60) % 60;
            const sec  = Math.floor(diffSeconds) % 60;

            return {
                days,
                hour,
                min,
                sec,
            };
        }
    };
});
